import { jfetch, snakeCaseKeys } from "../utils";

export function updateResourceCategory(
  id: string,
  resourceCat: IResourceCategory
) {
  const resourceCategory = snakeCaseKeys(resourceCat);
  return jfetch.put(`/resource_categories/${id}`, resourceCategory);
}

export function updateResource(id: string, resourceObj: any) {
  const resource = snakeCaseKeys(resourceObj);
  return jfetch.put(`/resources/${id}`, resource);
}



// WEBPACK FOOTER //
// ./app/javascript/libs/resources.ts